export class FiltrosRegistroDTO {
  classificacoes: ClassificacaoDTO[];
  search: string = "";
  dataInicial: Date = new Date();
  dataFinal: Date = new Date();
}

export class RegistroDTO {
  id: number;
  tenant: string;
  nome: string;
  telefone: string;
  uf: string;
  cadastro: Date;
}

export class ClassificacaoDTO {
  id: number;
  descricao: string;
}

export class RegistrosPorClassificacaoDTO {
  dia: RegistroDTO[];
  mes: RegistroDTO[];
  ano: RegistroDTO[];
  personalizado: RegistroDTO[];
  classificacao: ClassificacaoDTO;
}

export class RetornoConsultaRegistrosDTO {
  registros: RegistrosPorClassificacaoDTO[];
  filtros: FiltrosRegistroDTO;
}

export class FiltrosDetalhesDTO {
  tipo: "DIA" | "MES" | "ANO" | "PERSONALIZADO";
  registros: RegistroDTO[];
  dataInicial: Date = new Date();
  dataFinal: Date = new Date();
}

export class RetornoConsultaDetalhesDTO {
  dados: RetornoConsultaDetalhesValoresDTO;
  detalhes: DetalhesPorTenantDTO[];
}

export class DetalhesPorTenantDTO {
  tenant: string;
  dados: RetornoConsultaDetalhesValoresDTO;
}

export class RetornoConsultaDetalhesValoresDTO {
  login: {
    acessaramUltimos5: number;
    acessaramUltimos15: number;
    naoAcessaramUltimos15: number;
  };
  cadastro: number;
  lancamento: number;
  comercial: number;
  servico: number;
  total: number;
}
